import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { AuthenticationService } from '../services/auth/authentication.service';
import { CookieService } from '../services/common/cookie.service';
import { LocalStorageService } from '../services/common/local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private _cookieService: CookieService, private _authSvc: AuthenticationService,public _localService: LocalStorageService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    
    let user = this._authSvc.getUser();
    if (user !== undefined && user !== null) {

      const requiredClaimKey = this.getRequiredClaim(state.url);
      if (requiredClaimKey && !this._localService.checkClaim(requiredClaimKey)) {
        // Redirect user if they lack permission
        setTimeout(() => {
          this.router.navigate(['/error']);
      }, 100);
        return false;
      }
      return true;
      // return this._authSvc.isUserStampValid(user).pipe(
      //   map((e: any) => {
      //     // console.log(e);
      //     if (e.IsStampValid == true) {
      //       return true;
      //     } else {
      //       this._authSvc.logout();
      //       return false;
      //     }
      //   }),
      //   catchError((err) => {
      //     this.router.navigate(['/login']);
      //     return of(false);
      //   })
      // );
    } else {
      // not logged in so redirect to login page with the return url
      let url = state.url;
      if (state.url == '/dashboard') {
        this.router.navigate(['/login']);
      } else {
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
      }
      return false;
    }

  }

  private getRequiredClaim(url: string): string | null {
   
    // Define claim keys based on route patterns
    const claimMap = {
      '/garage-settings/vmh-report': this._localService.claimKeys.GARAGEVMHREPORTMODULE,
      '/item': this._localService.claimKeys.GARAGEITEMMODULE,
      '/vehicle': this._localService.claimKeys.GARAGEVEHICLEMODULE,
      '/vehicle-notify': this._localService.claimKeys.GARAGEVEHICLENOTIFYMODULE,
      '/purchase-requsition': this._localService.claimKeys.GARAGEPURCHASEREQUISITIONMODULE, 
      '/purchase-order': this._localService.claimKeys.GARAGEPURCHASEORDERMODULE,
      '/purchase': this._localService.claimKeys.GARAGEPURCHASEMODULE,
      '/all-sales-list': this._localService.claimKeys.GARAGEALLSALESMODULE,
      '/sale': this._localService.claimKeys.GARAGESALEMODULE,
      '/repair-order-list': this._localService.claimKeys.GARAGEREPAIRORDERMODULE,
      '/wip-repair-orders': this._localService.claimKeys.GARAGEWIPMODULE,
      '/ready-list': this._localService.claimKeys.GARAGEREADYLISTMODULE,
      '/payment-status': this._localService.claimKeys.GARAGEPAYMENTSTATUSMODULE,
      '/direct-sale-list': this._localService.claimKeys.GARAGEDIRECTSALEMODULE,
      '/direct-sale': this._localService.claimKeys.GARAGECREATEDIRECTSALEMODULE,
      '/garage-settings/stock-report': this._localService.claimKeys.GARAGEITEMSTOCKREPORTMODULE,
      '/garage-settings/agging-report': this._localService.claimKeys.GARAGEAGGINGREPORTMODULE,
      '/garage-settings/stock-adjustment-list': this._localService.claimKeys.GARAGESTOCKADJUSTMENTMODULE,
      '/all-invoices': this._localService.claimKeys.GARAGECUSTOMERSALESINVOICEREPORTMODULE,
      '/garage-settings/fule-type': this._localService.claimKeys.GARAGEFUELTYPEMODULE,
      '/garage-settings/model': this._localService.claimKeys.GARAGEVEHICLEMODELMODULE,
      '/garage-settings/brand': this._localService.claimKeys.GARAGEBRANDMODULE,
      '/garage-settings/manufacturer': this._localService.claimKeys.GARAGEMANUFACTURERMODULE,
      '/customer': this._localService.claimKeys.GARAGECUSTOMERSMODULE,
      '/supplier': this._localService.claimKeys.GARAGESUPPLIERMODULE,
      '/garage-settings/ss-category': this._localService.claimKeys.GARAGESSCATEGORYMODULE,
      '/garage-settings/tags': this._localService.claimKeys.GARAGETAGSMODULE,
      '/garage-settings/tags-type': this._localService.claimKeys.GARAGETAGSTYPEMODULE,
      '/garage-settings/package-type': this._localService.claimKeys.GARAGEPACKAGETYPEMODULE,
      '/garage-settings/package': this._localService.claimKeys.GARAGEPACKAGEMODULE,
      '/garage-settings/units': this._localService.claimKeys.GARAGEUNITSMODULE,
      '/garage-settings/countries': this._localService.claimKeys.GARAGECOUNTRIESMODULE,
      '/garage-settings/colors': this._localService.claimKeys.GARAGECOLORSMODULE,
      '/garage-settings/complains-and-suggestions': this._localService.claimKeys.GARAGECOMPLAINANDSERVICEMODULE,
      '/garage-settings/vehicle-status': this._localService.claimKeys.GARAGEVEHICLESTATUSMODULE,
      '/bulk-payments-list': this._localService.claimKeys.GARAGEBULKPAYMENTMODULE,
      '/garage-settings/warehouse': this._localService.claimKeys.GARAGEWAREHOUSEMODULE,
      '/stock-list': this._localService.claimKeys.GARAGEWAREHOUSESTOCKMODULE,
      '/inventory-flow-report': this._localService.claimKeys.GARAGEINVENTORYFLOWREPORTMODULE,
      '/garage-settings/warehouse-stock-report': this._localService.claimKeys.GARAGEWAREHOUSESTOCKREPORTMODULE,
      '/garage-settings/sales-report': this._localService.claimKeys.GARAGESALESREPORTMODULE,
      '/quotation': this._localService.claimKeys.GARAGEQUOTATIONMODULE,
      // Add more routes if needed
    };

    return claimMap[url] || null;
  }
  // constructor(private router: Router, private _authSvc: AuthenticationService) { }

  // canActivate(
  //   next: ActivatedRouteSnapshot,
  //   state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

  //     let user = this._authSvc.getUser();
  //     if (user !== undefined && user !== null) {

  //       return this._authSvc.isUserStampValid(user).pipe(
  //         map((e: any) => {
  //           console.log(e);

  //           if (e.IsStampValid == true) {
  //             return true;
  //           } else {
  //             this._authSvc.logout();
  //             return false;
  //           }
  //         }),
  //         catchError((err) => {
  //           this.router.navigate(['/account/login']);
  //           return of(false);
  //         })
  //       );
  //     } else {
  //       // not logged in so redirect to login page with the return url
  //       let url = state.url;
  //       if (state.url == '/dashboard') {
  //         this.router.navigate(['/account/login']);
  //       } else {
  //         this.router.navigate(['/account/login'], { queryParams: { returnUrl: state.url } });
  //       }
  //       return false;
  //     }
  //   return true;
  // }

}
